import React, { FC, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import DropdownSelector from 'components/DropdownSelector';
import SearchBox from 'components/SearchBox';
import Button from 'components/Button';
import TableItem, {
  HandleFormDataParams,
  TableItemDTO,
} from 'components/TableItem';

import { useAutoApproval } from 'hooks/useAutoApproval';

import {
  FormSecondSectionWrapper,
  FormHeader,
  TableWrapper,
  TableHeader,
  CourseInfo,
  ButtonsFooter,
} from './styles';

interface FormSecondSectionProps {
  selectedCourses: any;
  handleSaveAndExit: () => void;
}

const FormSecondSection: FC<FormSecondSectionProps> = ({
  selectedCourses,
  handleSaveAndExit,
}) => {
  const history = useHistory();
  const { removeTableItem } = useAutoApproval();

  const [checkboxHeaderValue, setCheckboxHeaderValue] = useState<boolean>(
    false,
  );
  const [tableListData, setTableListData] = useState<TableItemDTO[]>([]);
  const [needFillSomeInput, setNeedFillSomeInput] = useState(false);
  const [removeSelectedList, setRemoveSelectedList] = useState<any[]>([]);

  const handleFormData = useCallback(
    ({ index, currentData }: HandleFormDataParams): void => {
      if (tableListData.length < 3) {
        setTableListData((currArray) => [...currArray, currentData]);
        return;
      }

      const newArray = tableListData;
      newArray[index] = currentData;

      setTableListData(newArray);
    },
    [tableListData],
  );

  const handleSelectAllCoursesToRemove = () => {
    setCheckboxHeaderValue(!checkboxHeaderValue);
  };

  const removeAllSelectedItems = async () => {
    const promises: Promise<void>[] = [];
    removeSelectedList.forEach((item) => {
      promises.push(removeTableItem(item.id as number));
    });

    await Promise.all(promises);

    setRemoveSelectedList([]);
  };

  return (
    <FormSecondSectionWrapper>
      {/* }
      <FormHeader>
        <SearchBox placeHolder="Pesquisar curso"/>
        <DropdownSelector
          placeholder="Campus"
          data={[{ label: 'Campus I', value: 'Campus I' }]}
          isSmall
          width={200}
        />
        <DropdownSelector
          placeholder="Turno"
          data={[
            { label: 'Diurno', value: 'Diurno' },
            { label: 'Noturno', value: 'Noturno' },
          ]}
          isSmall
          width={136}
        />
      </FormHeader>
        */}
      <TableWrapper>
        <TableHeader>
          <CourseInfo>
            <input
              type="checkbox"
              id="selectAllCourses"
              checked={checkboxHeaderValue}
              onChange={(): void => handleSelectAllCoursesToRemove()}
            />
            <label htmlFor="selectAllCourses">Curso</label>
          </CourseInfo>

          <h4>Campus</h4>
          <h4>Limite de vagas</h4>
          <h4>Qtde vagas</h4>
          <h4>% de crédito</h4>
          <h4>Valor mensalidade</h4>
          <h4>Parcelas de cobertura</h4>
        </TableHeader>

        {selectedCourses.map((course, index) => (
          <TableItem
            key={course.id}
            course={course as any}
            index={index}
            headerChecked={checkboxHeaderValue}
            handleFormData={handleFormData}
            setNeedFillSomeInput={setNeedFillSomeInput}
            setRemoveSelectedList={setRemoveSelectedList}
            removeSelectedList={removeSelectedList}
          />
        ))}
      </TableWrapper>

      <ButtonsFooter>
        <Button
          disabled={removeSelectedList.length === 0}
          title="Apagar selecionados"
          onClick={removeAllSelectedItems}
          maxWidth={180}
        />

        <div className="btn-right-align">
          <Button
            maxWidth={200}
            backgroundColor="#ffffff"
            textColor="#4A90E2"
            border="2px solid #4A90E2"
            title="Salvar e continuar depois"
            onClick={() => {
              if (needFillSomeInput) {
                alert('Preencha todos os campos');
                return;
              }

              handleSaveAndExit();
              history.push('/aprovacao-automatica');
            }}
          />

          <Button
            maxWidth={200}
            marginLeft="20px"
            title="Finalizar aprovação automática"
            onClick={() => {
              if (needFillSomeInput) {
                alert('Preencha todos os campos');
                return;
              }

              handleSaveAndExit();
              history.push('/revisao');
            }}
          />
        </div>
      </ButtonsFooter>
    </FormSecondSectionWrapper>
  );
};

export default FormSecondSection;
